'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withForm = require('constructicon/with-form');

var _withForm2 = _interopRequireDefault(_withForm);

var _form = require('./form');

var _form2 = _interopRequireDefault(_form);

var _teams = require('../../api/teams');

var _form3 = require('constructicon/form');

var _form4 = _interopRequireDefault(_form3);

var _inputSearch = require('constructicon/input-search');

var _inputSearch2 = _interopRequireDefault(_inputSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var JoinTeamForm = function (_React$Component) {
  _inherits(JoinTeamForm, _React$Component);

  function JoinTeamForm() {
    _classCallCheck(this, JoinTeamForm);

    var _this = _possibleConstructorReturn(this, (JoinTeamForm.__proto__ || Object.getPrototypeOf(JoinTeamForm)).call(this));

    _this.filterResults = _this.filterResults.bind(_this);
    _this.handleJoinTeam = _this.handleJoinTeam.bind(_this);
    _this.state = {
      errors: [],
      results: [],
      status: null,
      teams: []
    };
    return _this;
  }

  _createClass(JoinTeamForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var campaign = this.props.campaign;


      var params = {
        campaign: campaign,
        limit: 1000
      };

      (0, _teams.fetchTeams)(params).then(function (teams) {
        return teams.map(_teams.deserializeTeam);
      }).then(function (teams) {
        return teams.map(function (team) {
          return {
            id: team.id,
            owner: team.owner,
            slug: team.slug,
            label: team.name
          };
        });
      }).then(function (teams) {
        return _this2.setState({ status: 'fetched', teams: teams });
      });
    }
  }, {
    key: 'filterResults',
    value: function filterResults(q) {
      var teams = this.state.teams;

      var results = teams.filter(function (team) {
        return team.label.toLowerCase().indexOf(q.toLowerCase()) !== -1;
      });
      this.setState({ results: results });
    }
  }, {
    key: 'handleJoinTeam',
    value: function handleJoinTeam(e) {
      var _this3 = this;

      e.preventDefault();
      var _props = this.props,
          form = _props.form,
          onSuccess = _props.onSuccess,
          pageId = _props.pageId,
          pageSlug = _props.pageSlug,
          token = _props.token;


      return form.submit().then(function (data) {
        _this3.setState({ status: 'fetching' });

        var params = {
          id: data.team.owner || data.team.id,
          page: pageId,
          pageSlug: pageSlug,
          teamSlug: data.team.slug,
          token: token
        };

        return Promise.resolve().then(function () {
          return (0, _teams.joinTeam)(params);
        }).then(function () {
          return (0, _teams.fetchTeam)(data.team.id);
        }).then(function (team) {
          return (0, _teams.deserializeTeam)(team);
        }).then(function (team) {
          _this3.setState({ status: 'fetched' });
          return onSuccess(team);
        }).catch(function (error) {
          var errors = [{ message: 'There was an unexpected error' }];
          _this3.setState({ status: 'failed', errors: errors });
          return Promise.reject(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          errors = _state.errors,
          results = _state.results,
          status = _state.status;
      var _props2 = this.props,
          form = _props2.form,
          formProps = _props2.formProps,
          inputProps = _props2.inputProps;


      return _react2.default.createElement(
        _form4.default,
        _extends({
          isLoading: status === 'fetching',
          noValidate: true,
          submit: 'Join Team',
          errors: errors,
          onSubmit: this.handleJoinTeam
        }, formProps),
        _react2.default.createElement(_inputSearch2.default, _extends({}, form.fields.team, {
          onBlur: function onBlur() {},
          onSearch: this.filterResults,
          results: results,
          valueFormatter: function valueFormatter(team) {
            return team.label;
          }
        }, inputProps))
      );
    }
  }]);

  return JoinTeamForm;
}(_react2.default.Component);

JoinTeamForm.propTypes = {
  /**
   * The campaignId you want to join teams in
   */
  campaign: _propTypes2.default.string,

  /**
   * Props to be passed to the Form component
   */
  formProps: _propTypes2.default.object,

  /**
   * Props to be passed to the InputField components
   */
  inputProps: _propTypes2.default.object,

  /**
   * The onSuccess event handler
   */
  onSuccess: _propTypes2.default.func.isRequired,

  /**
   * The page (id) you want to add to the team
   */
  pageId: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),

  /**
   * The page (slug) you want to add to the team
   */
  pageSlug: _propTypes2.default.string,

  /**
   * The logged in users' auth token
   */
  token: _propTypes2.default.string.isRequired
};

exports.default = (0, _withForm2.default)(_form2.default)(JoinTeamForm);